<script lang="ts">
	import { resolve } from '$app/paths';
	interface Props {
		classes?: string;
	}

	let { classes = 'text-sm text-surface-800-200 font-rethink' }: Props = $props();
</script>

<div class="flex flex-row items-center gap-2 {classes}">
	<a href={resolve('/submission')} target="_blank">Submission Terms</a>
	<span class="vr h-3 border-surface-800-200" role="separator" aria-hidden="true"
	></span>
	<a href={resolve('/terms')} target="_blank">Terms of Service</a>
	<span class="vr h-3 border-surface-800-200" role="separator" aria-hidden="true"
	></span>
	<a href={resolve('/privacy')} target="_blank">Privacy Policy</a>
</div>
